"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var components_lib_1 = require("@dynamynd/components-lib");

var core_1 = require("@dynamynd/core");

var responsive_1 = require("@dynamynd/responsive");

var react_1 = __importDefault(require("react"));

var styled_components_1 = __importDefault(require("styled-components"));

var ContentRowResponsive = styled_components_1.default(function (_a) {
  var activeBreakpoint = _a.activeBreakpoint,
      width = _a.width,
      rest = __rest(_a, ["activeBreakpoint", "width"]);

  return react_1.default.createElement(components_lib_1.RowCenteredResponsive, __assign({}, rest));
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    flex-grow: 1;\n    ", ";\n    margin: 0 auto;\n    z-index: 101;\n"], ["\n    flex-grow: 1;\n    ", ";\n    margin: 0 auto;\n    z-index: 101;\n"])), function (_a) {
  var activeBreakpoint = _a.activeBreakpoint,
      width = _a.width;
  var containerWidth = setContentRowResponsiveMaxWidth(activeBreakpoint, width);
  return "\n            min-width: " + containerWidth + "px;\n            max-width: " + containerWidth + "px;\n        ";
});
var defaultContentContainerWidth = 1240;
var minGutter = 60;
var defaultWidthBreakpoint = defaultContentContainerWidth + minGutter;

function setContentRowResponsiveMaxWidth(activeBreakpoint, screenWidth) {
  var gutter = core_1.getActiveGutterSize(activeBreakpoint);

  if (!responsive_1.isExtraLarge(activeBreakpoint) || screenWidth < defaultWidthBreakpoint) {
    return screenWidth - 2 * gutter;
  }

  return defaultContentContainerWidth;
}

exports.default = responsive_1.withResponsiveMeta(ContentRowResponsive);
var templateObject_1;